export function notifyBasketChanged(includeShoppingCart, fullCartResponse, lastItemAdded) {
    window?.SF?.notifyBasketChange?.({ includeShoppingCart, json: fullCartResponse, lastItemAdded });
}
